module.exports = __webpack_public_path__ + "static/media/RECLTD.2656fbdd.txt";